import { render } from "./testimonials.vue?vue&type=template&id=43b9cd4d&scoped=true"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"

import "./testimonials.vue?vue&type=style&index=0&id=43b9cd4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b9cd4d"]])

export default __exports__